import(/* webpackMode: "eager" */ "/app/apps/PublicUI/app/components/MarketplaceShell/Footer/styles.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["MarketplaceShellHeader"] */ "/app/apps/PublicUI/app/components/MarketplaceShell/Header/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/PublicUI/app/components/MarketplaceShell/styles.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["MarketplaceAppContext"] */ "/app/apps/PublicUI/contexts/AppContext/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
